import React, { useContext } from 'react';

interface IPreviewContext {
  appId: string;
  isPreview: boolean;
}
const PreviewContext: IPreviewContext = {
  appId: 'www.wix.com',
  isPreview: false,
};

export const PreviewMode = React.createContext<IPreviewContext>(PreviewContext);

export const PreviewModeContext = () => useContext(PreviewMode);
